// Copyright (c) 2022-2024. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import React from "react";
import { ComponentUtils } from "../../../../../../io/hyperify/frontend/components/utils/ComponentUtils";
import { COOKIES_ARTICLE_CLASS_NAME } from "../../../../core/constants/className";
import {
    META_PIXEL_PRIVACY_CONTENT_URL,
} from "../../../../core/constants/company";
import {
    T_COOKIES_VIEW_ACCEPT_ALL,
    T_COOKIES_VIEW_ACCEPT_ALL_TIP,
    T_COOKIES_VIEW_ACCEPT_MANDATORY,
    T_COOKIES_VIEW_ACCEPT_MANDATORY_TIP,
    T_COOKIES_VIEW_CONTENT,
    T_COOKIES_VIEW_META_CONTENT,
    T_COOKIES_VIEW_META_LINK_TEXT,
    T_COOKIES_VIEW_META_TITLE,
    T_COOKIES_VIEW_TITLE,
} from "../../../../core/constants/translation";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import { CookieConsentArticle } from "../cookieConsent/CookieConsentArticle";
import "./CookiesArticle.scss"

export interface CookiesProps {
    readonly t : TranslationFunction;
}

export function CookiesArticle (props: CookiesProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const metaDescription = [
        T_COOKIES_VIEW_META_CONTENT
    ]
    const paramBlocks = {
        BR: <br />,
        META_URL: <a href={META_PIXEL_PRIVACY_CONTENT_URL}>{t(T_COOKIES_VIEW_META_LINK_TEXT)}</a>,
    };
    const translationParams = {};
    return (
        <article className={COOKIES_ARTICLE_CLASS_NAME}>

            <header className={COOKIES_ARTICLE_CLASS_NAME+'-header'}>
                <h1>{t(T_COOKIES_VIEW_TITLE)}</h1>
                <p>{t(T_COOKIES_VIEW_CONTENT)}</p>
            </header>

            <article className={COOKIES_ARTICLE_CLASS_NAME+'-provider'}>
                <h3>{t(T_COOKIES_VIEW_META_TITLE)}</h3>
                {ComponentUtils.prepareParagraphNodes(t, metaDescription, paramBlocks, translationParams)}
            </article>

            <article className={COOKIES_ARTICLE_CLASS_NAME+'-article'}>
                <p><strong>{t(T_COOKIES_VIEW_ACCEPT_ALL)}</strong>: {t(T_COOKIES_VIEW_ACCEPT_ALL_TIP)}</p>
                <p><strong>{t(T_COOKIES_VIEW_ACCEPT_MANDATORY)}</strong>: {t(T_COOKIES_VIEW_ACCEPT_MANDATORY_TIP)}</p>
            </article>

            <div className={COOKIES_ARTICLE_CLASS_NAME+'-settings'}>
                <CookieConsentArticle t={t} />
            </div>
        </article>
    );
}
